import { EUR, renderSymbol } from 'services/currency'
import { format } from 'services/date-time'
import get from 'lodash/get'
import {
  TYPE_BROOKLYN,
  get as apiGet,
} from 'api-client'

export const AMBASSADORS_START_YEAR = 2021
export const PAYOUT_MIN = 300
const date = new Date()
const currentYear = date.getFullYear()
export const CURRENT_YEAR_START = format(new Date(`${currentYear}-01-01T14:00:00`), 'YYYY-MM-DD')
export const CURRENT_YEAR_END = format(new Date(`${currentYear}-12-31T14:00:00`), 'YYYY-MM-DD')

export const AMBASSADORS_PAGE_STATIC_KEY = 'ambassadorsPage'

export const PARTNER_DETAIL_TAB_VALUE = 'partner-details'
export const PARTNER_PAYOUTS_TAB_VALUE = 'partner-payouts'
export const PARTNER_SIGNUPS_TAB_VALUE = 'partner-signups'
export const PARTNER_CAMPAIGNS_TAB_VALUE = 'partner-campaigns'

/**
 * Format the correct currency value for the Ambassadors page
 * @param {number} amount
 * @param {string} currencyIso
 * @returns {string}
 */
export function formatAmount (options) {
  const {
    amount, currencyIso = 'USD', active = true, useSymbol = true,
  } = options
  const number = parseFloat(amount)
  if (Number.isNaN(Number(number)) || !active) {
    return '--'
  }

  let price = Math.abs(number).toFixed(2)
  price = String(price)
  if (useSymbol) {
    if (currencyIso === EUR) {
      price = `${price} ${renderSymbol(currencyIso)}`
    } else {
      price = `${renderSymbol(currencyIso)}${price}`
    }
  }

  return price
}

/**
 * Gets an ambassadors payout data
 * @param {Object} options the options
 * @param {Object} options.uuid the activity uuid
 * @param {Object} options.auth auth
 */
export async function getAmbassadorPayout ({ auth, year }) {
  const ambassadorUuid = auth.get('uuid')
  const response = await apiGet('/v1/ambassador/payouts', {
    ambassadorUuid,
    startDate: year ? format(new Date(`${year}-01-01T14:00:00`), 'YYYY-MM-DD') : CURRENT_YEAR_START,
    endDate: year ? format(new Date(`${year}-12-31T14:00:00`), 'YYYY-MM-DD') : CURRENT_YEAR_END,
  }, { auth }, TYPE_BROOKLYN)
  return get(response, 'body', {})
}
